import { getAuth } from "firebase/auth";
import { getReadyAuthUser } from "~/utils/auth/waitForAuthReady";
import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { apiClient, TenantTableLoaderResult } from "~/services/apiClient";
import { TenantListFilters } from "~/types";
import { getFilteredTenantList, loadCookiesData } from "~/utils";
import * as APITypes from "~/API";

const parseTenantListFilters = (
  searchParams: URLSearchParams
): TenantListFilters => {
  const filters: TenantListFilters = {};
  const statusRaw = searchParams.get("status");
  if (
    statusRaw &&
    (Object.values(APITypes.TenantStatusType) as string[]).includes(statusRaw)
  ) {
    filters.status = statusRaw as APITypes.TenantStatusType;
  }
  const typeRaw = searchParams.get("type");
  if (
    typeRaw &&
    (Object.values(APITypes.TenantType) as string[]).includes(typeRaw)
  ) {
    filters.type = typeRaw as APITypes.TenantType;
  }
  const searchRaw = searchParams.get("search");
  if (searchRaw?.trim()) {
    filters.search = searchRaw.trim();
  }
  return filters;
};

export const TenantTablePageLoader = async ({
  request,
}: LoaderFunctionArgs): Promise<TenantTablePageLoaderType | Response> => {
  const auth = getAuth();
  const user = await getReadyAuthUser();
  if (!user) return redirect("/explore");
  const authAccessInfo = await loadCookiesData(user?.uid || "");
  if (!authAccessInfo.success) return redirect("/explore");
  const { ownerID, ownerType } = authAccessInfo.data;

  const { searchParams } = new URL(request.url);
  const listFilters = parseTenantListFilters(searchParams);

  const result = await apiClient.loader<TenantTableLoaderResult>("tenant-table", {
    ownerID,
    ownerType,
  });

  if (!result.success || !result.data) {
    console.error("Failed to load tenants:", result.error);
    return redirect("/explore");
  }

  const rawList = result.data.tenantList ?? [];
  const tenantList = getFilteredTenantList({
    filters: listFilters,
    tenantList: rawList,
  });

  return {
    tenantList,
  };
};

export type TenantTablePageLoaderType = {
  tenantList: APITypes.Tenant[];
};

export const TenantTablePageAction = async () => {
  const auth = getAuth();
  const user = await getReadyAuthUser();
  if (!user) return redirect("/explore");
  const authAccessInfo = await loadCookiesData(user?.uid || "");
  if (!authAccessInfo.success) redirect("/explore");
  return {};
};
